// extracted by mini-css-extract-plugin
module.exports = {"app":"app_3g35f","main":"main_3vK6j","mobileMain":"mobileMain_1hlyl"};